import { Clock, Monitor, ArrowUpRight } from "lucide-react";
import { Reveal, ChapterHeading } from "./Reveal";
import PayButtons from "./PayButtons";
import { EDUCATION, waLink } from "@/config";

const Education = () => (
  <section id="egitimler" data-testid="education-section" className="relative z-10 py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <ChapterHeading
        chapter={EDUCATION.chapter}
        label={EDUCATION.label}
        title={EDUCATION.title}
        subtext={EDUCATION.subtext}
      />

      <div className={`mt-14 grid gap-6 ${EDUCATION.packages.length === 1 ? "max-w-xl mx-auto" : "md:grid-cols-2 lg:grid-cols-3"}`}>
        {EDUCATION.packages.map((pkg, i) => (
          <Reveal key={pkg.id} delay={i * 0.12} className="h-full">
            <article
              data-testid={pkg.testId}
              className="card-glow relative flex h-full flex-col rounded-2xl border border-gold/20 bg-navy-800/70 backdrop-blur-sm p-7 sm:p-8"
            >
              {pkg.badge && (
                <span className="absolute -top-3 left-7 rounded-full bg-gold px-4 py-1 text-[11px] font-semibold uppercase tracking-widest text-ink">
                  {pkg.badge}
                </span>
              )}
              <span className="font-mono text-xs text-gold/70 tracking-[0.25em]">
                {String(i + 1).padStart(2, "0")}
              </span>
              <h3 className="mt-4 font-serif text-2xl text-cream leading-snug">{pkg.title}</h3>
              <p className="mt-3 text-sm text-mist leading-relaxed flex-1">{pkg.description}</p>

              <div className="mt-6 space-y-2.5 text-sm text-cream/80">
                <div className="flex items-center gap-2.5">
                  <Clock className="w-4 h-4 text-gold" />
                  {pkg.duration}
                </div>
                <div className="flex items-center gap-2.5">
                  <Monitor className="w-4 h-4 text-gold" />
                  {pkg.format}
                </div>
              </div>

              <div className="mt-7 border-t border-gold/15 pt-6">
                <div className="flex items-baseline gap-3">
                  <span
                    className="font-serif text-3xl text-gold"
                    data-testid={`${pkg.testId}-price`}
                  >
                    {pkg.price}
                  </span>
                  <span className="text-xs text-mist">{pkg.priceNote}</span>
                </div>
                <a
                  href={waLink(pkg.waMessage)}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`${pkg.testId}-cta`}
                  className="group mt-5 inline-flex w-full items-center justify-center gap-2 rounded-full bg-gold px-6 py-3.5 text-sm font-semibold text-ink transition-all duration-300 hover:bg-gold-light hover:shadow-[0_0_28px_rgba(212,175,55,0.35)]"
                >
                  {pkg.cta}
                  <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </a>
                <PayButtons productId={pkg.id} title={pkg.title} testId={pkg.testId} />
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Education;
